export default {
    data() {
        const unitType =
            this.form && this.form.name.indexOf('Container') > -1 ? 'Container' : 'Tank';
        return {
            paramTpl: {
                unitType,
                unfp: 0,
                piH49: '',
                variant: 0,
                unNumber: 0,
                inLimitedQuantity: 0,
                inExceptedQuantity: 0,
                wasteExempt: true,
                unmp: true,
                packageNumber: 0,
                packageUnit: '',
                quantity: 0,
                quantityUnit: '',
            },
        };
    },
    methods: {
        getRelatedQuestionsValues(sections) {
            const params = [];
            sections.forEach((section) => {
                const questions = section.questions.map((question) => ({
                    name: question.tag,
                    value: question.data.display_value || question.data.return_value,
                }));
                const paramObj = { ...this.paramTpl };
                const unIdQuestion = questions.find((item) => item.name == 'UN/ID Number');
                const unIdValue = unIdQuestion?.value?.slice(0, 4) || '';
                if (unIdValue) {
                    const flashPointQuestion = questions.find((item) => item.name == 'Flash Point');
                    let flashPointValue = flashPointQuestion?.value || 0;

                    const flashPointFCQuestion = questions.find((item) => item.name == 'F or C');
                    const flashPointFCValue = flashPointFCQuestion?.value || 'C';

                    const checkAppliesQuestion = questions.find(
                        (item) => item.name == 'Check all that applies'
                    );
                    const checkAppliesValue = checkAppliesQuestion?.value?.split(',') || [];

                    const packageNumberQuestion = questions.find(
                        (item) => item.name == 'No.of Packages'
                    );
                    const packageNumberValue = packageNumberQuestion?.value || 0;

                    const packageUnitQuestion = questions.find(
                        (item) => item.name == 'Package Unit'
                    );
                    const packageUnitValue = packageUnitQuestion?.value || '';

                    const weightQuestion = questions.find(
                        (item) => item.name == 'Weight' || item.name == 'Quantity'
                    );
                    const weightValue = weightQuestion?.value || 0;

                    const weightUnitQuestion = questions.find(
                        (item) => item.name == 'Weight Unit' || item.name == 'Quantity Unit'
                    );
                    const weightUnitValue = weightUnitQuestion?.value || '';

                    const descriptionsQuestion = questions.find(
                        (item) => item.name == 'Descriptions'
                    );
                    const descriptionQuestionValue = descriptionsQuestion?.value || '';
                    const values = descriptionQuestionValue.split('\n');
                    let variantValue;
                    let pih49Value = '';
                    values.forEach((itemValue) => {
                        if (itemValue.indexOf('VARIANT') > -1) {
                            variantValue = itemValue.replace(/VARIANT:\s?(.*)/gi, '$1');
                        } else if (itemValue.indexOf('PIH49') > -1) {
                            pih49Value = itemValue.replace(/PIH49:\s?(.*)/gi, '$1');
                        }
                    });

                    if (flashPointFCValue == 'F' || flashPointFCValue == '1') {
                        flashPointValue = parseFloat(((flashPointValue - 32) / 1.8).toFixed(2));
                    }

                    paramObj.unfp = flashPointValue;
                    paramObj.piH49 = pih49Value;
                    paramObj.variant = parseInt(variantValue, 10);
                    paramObj.unNumber = unIdValue;
                    paramObj.inLimitedQuantity = checkAppliesValue.indexOf('1') > -1 ? 1 : 0;
                    paramObj.inExceptedQuantity = checkAppliesValue.indexOf('2') > -1 ? 1 : 0;
                    paramObj.wasteExempt = checkAppliesValue.indexOf('4') > -1;
                    paramObj.unmp = checkAppliesValue.indexOf('3') > -1;
                    paramObj.packageNumber = parseFloat(packageNumberValue);
                    paramObj.packageUnit = packageUnitValue;
                    paramObj.quantity = parseFloat(weightValue);
                    paramObj.quantityUnit = weightUnitValue;

                    params.push(paramObj);
                }
            });

            return params;
        },
    },
};
